module.exports = __webpack_public_path__ + "static/img/8.e0ce8cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/8.png
// module id = JSUV
// module chunks = 4